// Omnix/client/ui/TemplateEditorField.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TemplateEditorField extends ComponentBase {
    static styles = `
        .template-editor-field-wrapper {
            padding: 0.5rem;
            border: 1px solid var(--bs-border-color);
            border-radius: var(--bs-border-radius);
            background-color: var(--bs-tertiary-bg);
            text-align: center;
        }
    `;

    constructor(config) {
        super(config);
        this.value = null; // This will hold the template body (string or object)
        this.channelType = 'email'; // Default
        this.emailEditor = null;
        this.messagingEditor = null;
        this.applyStyles();
    }

    // Called by DataForm whenever any field in the form changes.
    // This is how we know which channel is selected.
    onParentFormUpdate(formData) {
        if (formData.channelType && this.channelType !== formData.channelType) {
            this.channelType = formData.channelType;
           // this.render(); // Re-render to update the button text/state
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'template-editor-field-wrapper';
        }
        const buttonText = this.value ? 'Edit Template Content' : 'Configure Template Content';
        this.container.innerHTML = `
            <button type="button" class="btn btn-secondary w-100">
                <i class="bi bi-pencil-square me-2"></i> ${this.t(buttonText)}
            </button>
        `;
        this.container.querySelector('button').addEventListener('click', () => this.showEditor());
        return this.container;
    }

  async showEditor() {
        if (this.channelType === 'email') {
            if (!this.emailEditor) {
                this.emailEditor = await this.createManagedComponent('EmailTemplateEditor', document.body, {
                    instanceId: `${this.config.instanceId}-email-editor`
                });
                this.emailEditor.on('saved', (data) => {
                    // --- THIS IS THE FIX ---
                    // The user has explicitly saved. Now we update our value
                    // AND notify the parent DataForm that a change has occurred.
                    this.setValue(data);
                    this.emailEditor.hide();
                    this.container.dispatchEvent(new Event('change', { bubbles: true }));
                    // --- END OF FIX ---
                });
            }
            this.emailEditor.show(this.value);
        } else { // sms, whatsapp, etc.
            if (!this.messagingEditor) {
                this.messagingEditor = await this.createManagedComponent('MessagingTemplateEditor', document.body, {
                    instanceId: `${this.config.instanceId}-messaging-editor`
                });
                this.messagingEditor.on('saved', (data) => {
                    // --- THIS IS THE FIX (for the messaging editor) ---
                    this.setValue(data);
                    this.messagingEditor.hide();
                    this.container.dispatchEvent(new Event('change', { bubbles: true }));
                    // --- END OF FIX ---
                });
            }
            this.messagingEditor.show(this.value, this.channelType);
        }
    }

    getValue() {
        return this.value;
    }

    setValue(data) {
        this.value = data;
        this.render(); // Re-render to update button text
        // this.container.dispatchEvent(new Event('change', { bubbles: true }));
    }


    destroy() {
        this.emailEditor?.destroy();
        this.messagingEditor?.destroy();
        super.destroy();
    }
}
